import type { DashboardCommon } from "@/api/custom_types";
import CoinIcon from "@/assets/images/coin.svg?react";
import { useTranslation } from "@/hooks";
import { formatNumber } from "@/utils/tools";
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
	Typography,
} from "@st-marketplace/ui";

const DashboardLayoutHeaderStock = ({ data }: { data?: DashboardCommon }) => {
	const { t } = useTranslation();
	const total = data?.own_available_coins.value || 0;
	const ready = data?.own_snipe_ready_coins ?? total;

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<div className="flex items-center gap-1.5 text-secondary-text">
					<CoinIcon className="size-5" />
					<Typography variant="body-sm" className="tabular-nums">
						{formatNumber(total, "count")}
					</Typography>
					{/* only worth showing while some senders are on snipe cooldown */}
					{ready < total && (
						<Typography
							variant="caption"
							className="tabular-nums text-secondary-text-100"
						>
							({formatNumber(ready, "count")} {t("header.snipeReady")})
						</Typography>
					)}
				</div>
			</TooltipTrigger>
			<TooltipContent>
				<div className="flex flex-col gap-0.5 tabular-nums">
					<span>
						{t("header.totalStock")}: {formatNumber(total, "count")}
					</span>
					<span>
						{t("header.snipeReady")}: {formatNumber(ready, "count")}
					</span>
				</div>
			</TooltipContent>
		</Tooltip>
	);
};

export default DashboardLayoutHeaderStock;
